import { Button } from "@shared/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AddNewProduct = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Link to="/products/create">
        <Button className="flex gap-2">
          <PlusCircle />{" "}
          <span>{t("action.add", { entity: t("products.product") })}</span>
        </Button>
      </Link>
    </div>
  );
};

export default AddNewProduct;
